import dotPropImmutable from 'dot-prop-immutable';
import { insert } from '../utils';
export const entitiesSlice = {
    updateProjectPhaseTemplateEntityOrder: (state, { payload })=>{
        var _payload_insertAt;
        var _payload_entity_projectPhase, _payload_projectPhase;
        const previousPhaseId = (_payload_entity_projectPhase = payload.entity.projectPhase) === null || _payload_entity_projectPhase === void 0 ? void 0 : _payload_entity_projectPhase.projectPhaseId;
        let updated;
        if (previousPhaseId) {
            var _state_data_state_activeId_projectPhases_previousPhaseId_entityOrder;
            const previousEntityOrder = (_state_data_state_activeId_projectPhases_previousPhaseId_entityOrder = state.data[state.activeId].projectPhases[previousPhaseId].entityOrder) !== null && _state_data_state_activeId_projectPhases_previousPhaseId_entityOrder !== void 0 ? _state_data_state_activeId_projectPhases_previousPhaseId_entityOrder : [];
            updated = dotPropImmutable.set(state, `data.${state.activeId}.projectPhases.${previousPhaseId}.entityOrder`, previousEntityOrder.filter((id)=>id !== payload.entityId));
        }
        updated !== null && updated !== void 0 ? updated : updated = state;
        const phaseId = (_payload_projectPhase = payload.projectPhase) === null || _payload_projectPhase === void 0 ? void 0 : _payload_projectPhase.projectPhaseId;
        if (!phaseId) {
            return updated;
        }
        const order = dotPropImmutable.get(updated, `data.${state.activeId}.projectPhases.${phaseId}.entityOrder`, []);
        return dotPropImmutable.set(updated, `data.${state.activeId}.projectPhases.${phaseId}.entityOrder`, insert(order, (_payload_insertAt = payload.insertAt) !== null && _payload_insertAt !== void 0 ? _payload_insertAt : -1, payload.entityId));
    }
};
